var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "row form-group" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("label", [
            _vm._v(
              _vm._s(
                _vm.resource("JourneyBuilder_TimerSettings_DailyFrequency")
              )
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row form-group" }, [
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c("settings-property", {
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function(ref) {
                    var id = ref.id
                    return [
                      _c("label", { attrs: { for: id } }, [
                        _vm._v(
                          _vm._s(
                            _vm.resource(
                              "JourneyBuilder_TimerSettings_DailyFrequency_Frequency_Label"
                            )
                          )
                        )
                      ])
                    ]
                  }
                },
                {
                  key: "input",
                  fn: function(ref) {
                    var id = ref.id
                    return [
                      _c("v-select", {
                        staticClass: "form-control",
                        attrs: {
                          options: _vm.FREQUENCY_OPTIONS,
                          disabled: !_vm.canWrite,
                          clearable: false,
                          "input-id": id,
                          searchable: "",
                          filterable: ""
                        },
                        model: {
                          value: _vm.frequencyModel,
                          callback: function($$v) {
                            _vm.frequencyModel = $$v
                          },
                          expression: "frequencyModel"
                        }
                      })
                    ]
                  }
                },
                {
                  key: "errors",
                  fn: function() {
                    return [
                      _vm.$v.$dirty && _vm.$v.frequency.$invalid
                        ? _c("required-error-message")
                        : _vm._e()
                    ]
                  },
                  proxy: true
                }
              ])
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.frequencyModel === _vm.FREQUENCIES.MULTIPLE_TIMES
        ? [
            _c("div", { staticClass: "row form-group" }, [
              _c("div", { staticClass: "col-2" }, [
                _c("label", [
                  _vm._v(
                    _vm._s(
                      _vm.resource(
                        "JourneyBuilder_TimerSettings_DailyFrequency_Recurrence_Label"
                      )
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-10" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-5" },
                    [
                      _c("v-select", {
                        staticClass: "form-control",
                        attrs: {
                          options:
                            (_vm.recurrenceUnitModel &&
                              _vm.recurrenceUnitModel.recurrenceOptions) ||
                            [],
                          disabled: !_vm.canWrite,
                          clearable: false,
                          searchable: "",
                          filterable: ""
                        },
                        model: {
                          value: _vm.recursInUnitModel,
                          callback: function($$v) {
                            _vm.recursInUnitModel = $$v
                          },
                          expression: "recursInUnitModel"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-7" },
                    [
                      _c("v-select", {
                        staticClass: "form-control",
                        attrs: {
                          options: _vm.RECURRENCE_UNIT_OPTIONS,
                          disabled: !_vm.canWrite,
                          clearable: false,
                          searchable: "",
                          filterable: ""
                        },
                        model: {
                          value: _vm.recurrenceUnitModel,
                          callback: function($$v) {
                            _vm.recurrenceUnitModel = $$v
                          },
                          expression: "recurrenceUnitModel"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "offset-2 col-10" },
                [
                  _vm.$v.$dirty && _vm.$v.recursInSeconds.$invalid
                    ? _c("required-error-message")
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row form-group" }, [
              _c(
                "div",
                { staticClass: "col-6" },
                [
                  _c("settings-property", {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "label",
                          fn: function() {
                            return [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.resource(
                                      "JourneyBuilder_TimerSettings_DailyFrequency_StartTime_Label"
                                    )
                                  )
                                )
                              ])
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "input",
                          fn: function() {
                            return [
                              _c("time-picker", {
                                attrs: { readonly: !_vm.canWrite },
                                model: {
                                  value: _vm.startTimeModel,
                                  callback: function($$v) {
                                    _vm.startTimeModel = $$v
                                  },
                                  expression: "startTimeModel"
                                }
                              })
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "errors",
                          fn: function() {
                            return [
                              _vm.$v.$dirty && _vm.$v.startTime.$invalid
                                ? _c("required-error-message")
                                : _vm._e()
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      3078680035
                    )
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-6" },
                [
                  _c("settings-property", {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "label",
                          fn: function() {
                            return [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.resource(
                                      "JourneyBuilder_TimerSettings_DailyFrequency_EndTime_Label"
                                    )
                                  )
                                )
                              ])
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "input",
                          fn: function() {
                            return [
                              _c("time-picker", {
                                attrs: {
                                  "disabled-to": _vm.startTimeModel,
                                  readonly: !_vm.canWrite
                                },
                                model: {
                                  value: _vm.endTimeModel,
                                  callback: function($$v) {
                                    _vm.endTimeModel = $$v
                                  },
                                  expression: "endTimeModel"
                                }
                              })
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "errors",
                          fn: function() {
                            return [
                              _vm.$v.$dirty && !_vm.$v.endTime.required
                                ? _c("required-error-message", {
                                    staticClass: "d-block"
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.$v.$dirty &&
                              !_vm.$v.endTime.isOnOrAfterStartTime
                                ? _c("equal-or-greater-error-message", {
                                    staticClass: "d-block",
                                    attrs: {
                                      "field-name": _vm.resource(
                                        "JourneyBuilder_TimerSettings_DailyFrequency_EndTime_Label"
                                      ),
                                      "other-field-name": _vm.resource(
                                        "JourneyBuilder_TimerSettings_DailyFrequency_StartTime_Label"
                                      )
                                    }
                                  })
                                : _vm._e()
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      2518749391
                    )
                  })
                ],
                1
              )
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.frequencyModel === _vm.FREQUENCIES.ONCE
        ? [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-6" },
                [
                  _c("settings-property", {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "label",
                          fn: function() {
                            return [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.resource(
                                      "JourneyBuilder_TimerSettings_DailyFrequency_StartTimeOnce_Label"
                                    )
                                  )
                                )
                              ])
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "input",
                          fn: function() {
                            return [
                              _c("time-picker", {
                                model: {
                                  value: _vm.startTimeModel,
                                  callback: function($$v) {
                                    _vm.startTimeModel = $$v
                                  },
                                  expression: "startTimeModel"
                                }
                              })
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "errors",
                          fn: function() {
                            return [
                              _vm.$v.$dirty && _vm.$v.startTime.$invalid
                                ? _c("required-error-message")
                                : _vm._e()
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      72377624
                    )
                  })
                ],
                1
              )
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row form-group" }, [
      _c("div", { staticClass: "col-12" }, [_c("hr")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }